import makeAxiosRequest from './axios.instance';

const api = {
  auth: {
    signUp: makeAxiosRequest('/auth/sign-up/web', 'post'),
    invitesBulk: makeAxiosRequest('invites/bulk', 'post'),
    sendPasswordReset: makeAxiosRequest('/auth/send-password-reset', 'post'),
    resendVerificationEmail: makeAxiosRequest('/auth/resend-verification-email', 'post'),
    updatePassword: makeAxiosRequest((id) => `/users/${id}/password`, 'patch'),
  },
};

export default api;
